<template>
  <div class="callout">
    <div class="callout-header">{{labels}}</div>
    <span class="closebtn" onclick="this.parentElement.style.display='none';">×</span>
    <div class="callout-container">
        <p><slot></slot></p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.callout {
  position: fixed;
  display: none; // remove for display
  bottom: 35px;
  right: 20px;
  margin-left: 20px;
  max-width: 300px;
  z-index: 1000;
  border: transparent;
  border-radius: 1em;
}

.callout-header {
  padding: 15px 5px;
  background: #555;
  font-size: 20px;
  color: white;
}

.callout-container {
  padding: 15px;
  background-color: #ccc;
  color: black;
  min-width:200px
}

.closebtn {
  position: absolute;
  top: 5px;
  right: 20px;
  color: white;
  font-size: 30px;
  cursor: pointer;
}

.closebtn:hover {
  color: lightgrey;
}
</style>
<script>
export default {
    props: ["cancelLink", "labels", "variants", "content", "showSaveOnly"],
    created(){
        console.log('this',this);
    }
}
</script>